import { useState } from 'react';
import { DrawdownGroupItem } from './DrawdownGroupItem';
import type { DrawdownGroup } from '../../types/drawdown';

interface DrawdownGroupedViewProps {
  drawdowns: DrawdownGroup[];
  fundId: string;
  onRecalculate: (drawdownId: string) => void;
  onPreviewDrawdown: (drawdownId: string) => void;
  onPreviewBatch: (drawdownId: string, batchId: string) => void;
  onExpandDrawdown?: (drawdownId: string) => void | Promise<void>;
  loadingBatches?: Set<string>;
}

export const DrawdownGroupedView = ({
  drawdowns,
  fundId,
  onRecalculate,
  onPreviewDrawdown,
  onPreviewBatch,
  onExpandDrawdown,
  loadingBatches = new Set(),
}: DrawdownGroupedViewProps) => {
  const [expandedGroups, setExpandedGroups] = useState<Set<string>>(
    () => new Set()
  );

  const toggleGroup = async (drawdownNumber: string, drawdownId: string) => {
    const isExpanding = !expandedGroups.has(drawdownNumber);

    setExpandedGroups((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(drawdownNumber)) {
        newSet.delete(drawdownNumber);
      } else {
        newSet.add(drawdownNumber);
      }
      return newSet;
    });

    // Trigger batch loading when expanding
    if (isExpanding && onExpandDrawdown) {
      await onExpandDrawdown(drawdownId);
    }
  };

  return (
    <div className="space-y-1">
      {drawdowns.map((group) => (
        <DrawdownGroupItem
          key={group.drawdownNumber}
          group={group}
          fundId={fundId}
          isExpanded={expandedGroups.has(group.drawdownNumber)}
          isLoading={loadingBatches.has(group.drawdownId)}
          onToggle={() => toggleGroup(group.drawdownNumber, group.drawdownId)}
          onRecalculate={onRecalculate}
          onPreviewDrawdown={onPreviewDrawdown}
          onPreviewBatch={onPreviewBatch}
        />
      ))}
    </div>
  );
};
